// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lbvO","label":"styles_label__1WLCQ"};